import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Student } from 'src/app/models/student';
import { StudentEnrollment } from 'src/app/models/student-enrollment';
import { EnrollService } from 'src/app/services/enroll/enroll.service';
import { FormsModule } from '@angular/forms';
import { NamePipe } from 'src/app/pipes/name.pipe';

@Component({
  selector: 'li-student-enroll',
  templateUrl: './student-enroll.component.html',
  styleUrls: ['./student-enroll.component.scss'],
  standalone: true,
  imports: [FormsModule, NamePipe]
})
export class StudentEnrollComponent implements OnInit {
  @Input()
  public student?: Student;

  @Output()
  public closing = new EventEmitter();

  public get model(): Student {
    return this.student || <Student>{};
  }

  public constructor(private enrollService: EnrollService) {}

  public ngOnInit() {}

  public enroll(enrollment: StudentEnrollment) {
    enrollment.begin = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
    enrollment.end = formatDate(new Date('2100-01-01'), 'yyyy-MM-dd', 'en-US');
  }

  public deroll(enrollment: StudentEnrollment) {
    enrollment.begin = '';
    enrollment.end = '';
  }

  public close(): void {
    this.closing.emit();
  }

  public save(): void {
    if (!this.student) {
      this.closing.emit();
      return;
    }

    this.enrollService
      .set(
        this.student.sid,
        this.student.enrollments.filter(e => e.begin)
      )
      .subscribe(_ => this.closing.emit());
  }

  public visibility(): string {
    return this.student ? 'show' : 'hidden';
  }
}
